import Footer from '../../Components/Footer'
import { useTranslation } from 'react-i18next'
import { Avatar, Box, Container, Divider, List, ListItem, ListItemAvatar, ListItemText } from '@mui/material';
import { Variants, motion } from "framer-motion"
import DrawerAppBar from '../../Components/DrawerAppBar';
import Menus from '../../Components/Menus';
import TitrePage from '../../Components/TitrePage';
import { TextFields } from '@mui/icons-material';
import React from 'react';
import EllipseGauche from "../../Fichiers/Ellipse 200.svg"
import EllipseDroite from "../../Fichiers/Ellipse 201.svg"
import illution_4 from "../../Fichiers/illution_4.svg";

interface Props { }

function PretPourParticuliers(props: Props) {
        const { t } = useTranslation();
        

    const scroll: Variants = {
        offscreen: {
            x: 80,
            opacity: .3
        },
        onscreen: {
            x: 0,
            opacity: 1,
            transition: {
                bounce: 0.6,
                duration: 1
            }
        }
    };


    return (
        <div style={{ backgroundColor: "inherit" }}>
            <DrawerAppBar /><br />
            <Menus />
            <TitrePage titre={'PRODUITS_SERVICES.titre28'} lien={'Label.Titre.titre11'} />
            <br /><br /><br /><br /><br /><br /><br /><br />



            <Box display={"flex"} lineHeight={1.6} textAlign={"justify"}>
                <img style={{ width: "5%", marginRight: "2%" }} draggable={false} src={EllipseGauche} alt="" />

                <Container maxWidth='lg'>

                    <Box display={{ xs: 'block', sm: 'flex' }} >

                        <Box textAlign={"justify"}>
                            <motion.div
                                initial="offscreen"
                                whileInView="onscreen"
                                viewport={{ once: true, amount: 0.8 }}
                                variants={scroll}
                                className='produitsEtServices'
                            >
                                <br />
                                <img width={"80%"} src={illution_4} alt="" /><br /><br />

                            </motion.div>
                            <label style={{ fontSize: 'xx-large', fontWeight: "bold", color: "#40805C" }} htmlFor="">{t("PRETS_AMORTISSABLES_AUX_PARTICULIERS.texte.partie1")}</label>
                            <br /><br />
                            <label className='textgray' style={{ fontSize: 'large', fontWeight: "bold" }} htmlFor="">
                                {t("PRETS_AMORTISSABLES_AUX_PARTICULIERS.texte.partie2")}
                            </label>
                            <br /><br />
                            <List style={{ borderLeft: "5px #FFA412 solid" }}>
                                {(t("PRETS_AMORTISSABLES_AUX_PARTICULIERS.texte.partie21").split("|")).map((t) => (
                                    <>
                                        <ListItem>
                                            <ListItemAvatar>
                                                <Avatar alt="Remy Sharp"><TextFields /></Avatar>
                                            </ListItemAvatar>
                                            <ListItemText
                                                primary={t}
                                            />
                                        </ListItem>
                                        <Divider variant="inset" component="li" />
                                    </>
                                ))}
                            </List>

                        </Box>
                        <Box width={120} />
                        <motion.div
                            initial="offscreen"
                            whileInView="onscreen"
                            viewport={{ once: true, amount: 0.8 }}
                            variants={scroll}
                            className='produitsEtServices'
                        >
                            <Box>
                                <motion.div
                                    whileHover={{ scale: 1, rotate: 1 }}
                                    whileTap={{
                                        scale: 1,
                                        rotate: -1,
                                    }}
                                >
                                    <center><br /><br />
                                        <Box>
                                            <div><img style={{ borderRadius: "10%" }} width={300} height={300} src={require("../../Database/Files/ProduitsEtServices/Comptes/image 7.png")} alt="" /></div>
                                        </Box>
                                    </center>
                                </motion.div>
                            </Box>
                        </motion.div>
                    </Box>
                    <br />
                    <label className='textgray' htmlFor="">
                        {t("PRETS_AMORTISSABLES_AUX_PARTICULIERS.texte.partie22")}
                    </label>
                    <br />
                    <List style={{ borderLeft: "5px #FFA412 solid" }}>
                        {(t("PRETS_AMORTISSABLES_AUX_PARTICULIERS.texte.partie23").split("|")).map((t) => (
                            <>
                                <ListItem>
                                    <ListItemAvatar>
                                        <Avatar alt="Remy Sharp"><TextFields /></Avatar>
                                    </ListItemAvatar>
                                    <ListItemText
                                        primary={t}
                                    />
                                </ListItem>
                                <Divider variant="inset" component="li" />
                            </>
                        ))}
                    </List>
                    <br /><br />
                    <img width={"80%"} src={illution_4} alt="" /><br /><br />
                    <motion.div
                        initial="offscreen"
                        whileInView="onscreen"
                        viewport={{ once: true, amount: 0.8 }}
                        variants={scroll}
                        className='produitsEtServices'
                    >
                        <label className='textgray' style={{ fontSize: 'large', fontWeight: "bold" }} htmlFor="">
                            {t("PRETS_AMORTISSABLES_AUX_PARTICULIERS.texte.partie3").toUpperCase()}
                        </label>
                    </motion.div>
                    <br /><br />


                    <Box display={{ xs: 'block', sm: 'flex' }}>

                        <motion.div
                            initial="offscreen"
                            whileInView="onscreen"
                            viewport={{ once: true, amount: 0.8 }}
                            variants={scroll}
                            className='produitsEtServices'
                        >
                            <Box gap={20}>
                                <motion.div
                                    whileHover={{ scale: 1, rotate: 1 }}
                                    whileTap={{
                                        scale: 1,
                                        rotate: -1,
                                    }}
                                >
                                    <img style={{ borderRadius: "10%" }} width={300} src={require("../../Database/Files/pret/travel-again-concept-arrangement-with-copy-space 1.png")} alt="" />
                                </motion.div>
                            </Box>
                        </motion.div>
                        <Box width={100} />
                        <Box width={"100%"}>
                            <motion.div
                                initial="offscreen"
                                whileInView="onscreen"
                                viewport={{ once: true, amount: 0.8 }}
                                variants={scroll}
                                className='produitsEtServices'
                            >

                                <img width={"50%"} src={illution_4} alt="" /> <br />
                                <label className='textgray' htmlFor="" style={{ fontSize: 'x-large', fontWeight: "bold", color: "#40805C" }}>
                                    {t("PRETS_AMORTISSABLES_AUX_PARTICULIERS.texte.partie4").toUpperCase()}
                                </label>
                            </motion.div>
                            <br />
                            <motion.div
                                initial="offscreen"
                                whileInView="onscreen"
                                viewport={{ once: true, amount: 0.8 }}
                                variants={scroll}
                                className='produitsEtServices'
                            >
                                <label className='textgray' style={{ width: "30%", textAlign: "justify" }} htmlFor="">
                                    {t("PRETS_AMORTISSABLES_AUX_PARTICULIERS.texte.partie5")}
                                </label>
                                <br /><br />
                                <label className='textgray' style={{ width: "30%", textAlign: "justify" }} htmlFor="">
                                    {t("PRETS_AMORTISSABLES_AUX_PARTICULIERS.texte.partie6")}
                                </label>
                            </motion.div>

                        </Box>
                    </Box>
                    <br /><br />
                    <label className='textgray' style={{ width: "30%", textAlign: "justify" }} htmlFor="">
                        {t("PRETS_AMORTISSABLES_AUX_PARTICULIERS.texte.partie24")}
                    </label>
                    <br /><br />
                    <label className='textgray' style={{ width: "30%", textAlign: "justify", fontWeight: "bold" }} htmlFor="">
                        {t("PRETS_AMORTISSABLES_AUX_PARTICULIERS.texte.partie25")}
                    </label>
                    <List style={{ borderLeft: "5px #FFA412 solid" }}>
                        {(t("PRETS_AMORTISSABLES_AUX_PARTICULIERS.texte.partie26").split("|")).map((t) => (
                            <>
                                <ListItem>
                                    <ListItemAvatar>
                                        <Avatar alt="Remy Sharp"><TextFields /></Avatar>
                                    </ListItemAvatar>
                                    <ListItemText
                                        primary={t}
                                    />
                                </ListItem>
                                <Divider variant="inset" component="li" />
                            </>
                        ))}
                    </List>
                    <label className='textgray' style={{ width: "30%", textAlign: "justify", fontWeight: "bold" }} htmlFor="">
                        {t("PRETS_AMORTISSABLES_AUX_PARTICULIERS.texte.partie27")}
                    </label>
                    <List style={{ borderLeft: "5px #FFA412 solid" }}>
                        {(t("PRETS_AMORTISSABLES_AUX_PARTICULIERS.texte.partie28").split("|")).map((t) => (
                            <>
                                <ListItem>
                                    <ListItemAvatar>
                                        <Avatar alt="Remy Sharp"><TextFields /></Avatar>
                                    </ListItemAvatar>
                                    <ListItemText
                                        primary={t}
                                    />
                                </ListItem>
                                <Divider variant="inset" component="li" />
                            </>
                        ))}
                    </List>
                    <label className='textgray' style={{ width: "30%", textAlign: "justify", fontWeight: "bold" }} htmlFor="">
                        {t("PRETS_AMORTISSABLES_AUX_PARTICULIERS.texte.partie29")}
                    </label>
                    <List style={{ borderLeft: "5px #FFA412 solid" }}>
                        {(t("PRETS_AMORTISSABLES_AUX_PARTICULIERS.texte.partie30").split("|")).map((t) => (
                            <>
                                <ListItem>
                                    <ListItemAvatar>
                                        <Avatar alt="Remy Sharp"><TextFields /></Avatar>
                                    </ListItemAvatar>
                                    <ListItemText
                                        primary={t}
                                    />
                                </ListItem>
                                <Divider variant="inset" component="li" />
                            </>
                        ))}
                    </List>

                    <label className='textgray' style={{ width: "30%", textAlign: "justify", fontWeight: "bold" }} htmlFor="">
                        {t("PRETS_AMORTISSABLES_AUX_PARTICULIERS.texte.partie31")}
                    </label>
                    <List style={{ borderLeft: "5px #FFA412 solid" }}>
                        {(t("PRETS_AMORTISSABLES_AUX_PARTICULIERS.texte.partie32").split("|")).map((t) => (
                            <>
                                <ListItem>
                                    <ListItemAvatar>
                                        <Avatar alt="Remy Sharp"><TextFields /></Avatar>
                                    </ListItemAvatar>
                                    <ListItemText
                                        primary={t}
                                    />
                                </ListItem>
                                <Divider variant="inset" component="li" />
                            </>
                        ))}
                    </List>
                    <br />
                    <label className='textgray' htmlFor="">
                        {t("PRETS_AMORTISSABLES_AUX_PARTICULIERS.texte.partie33")}
                    </label>
                    <br />
                    <Box >
                        <img width={"50%"} src={illution_4} alt="" /> <br />
                        <Box width={20} />
                        <motion.div
                            initial="offscreen"
                            whileInView="onscreen"
                            viewport={{ once: true, amount: 0.8 }}
                            variants={scroll}
                            className='produitsEtServices'
                        >

                            <label className='textgray' style={{ fontSize: 'x-large', fontWeight: "bold", color: "#40805C", width: "100%" }} htmlFor="">
                                {t("PRETS_AMORTISSABLES_AUX_PARTICULIERS.texte.partie7").toUpperCase()}
                            </label>
                        </motion.div>
                    </Box>
                    <br />
                    <Box display={"flex"} gap={20}>
                        <Box>
                            <motion.div
                                initial="offscreen"
                                whileInView="onscreen"
                                viewport={{ once: true, amount: 0.8 }}
                                variants={scroll}
                                className='produitsEtServices'
                            >
                                <label className='textgray' style={{ width: "30%", textAlign: "justify", fontSize: "large" }} htmlFor="">
                                    {t("PRETS_AMORTISSABLES_AUX_PARTICULIERS.texte.partie8")}
                                </label><br /><br />
                                <List style={{ borderLeft: "5px #FFA412 solid" }}>
                                    {(t("PRETS_AMORTISSABLES_AUX_PARTICULIERS.texte.partie9").split("|")).map((t) => (
                                        <>
                                            <ListItem>
                                                <ListItemAvatar>
                                                    <Avatar alt="Remy Sharp"><TextFields /></Avatar>
                                                </ListItemAvatar>
                                                <ListItemText
                                                    primary={t}
                                                />
                                            </ListItem>
                                            <Divider variant="inset" component="li" />
                                        </>
                                    ))}
                                </List>
                                <br />
                                <label className='textgray' htmlFor="">
                                    {t("PRETS_AMORTISSABLES_AUX_PARTICULIERS.texte.partie10")}
                                </label>
                                <br /><br />
                                <label className='textgray' htmlFor="">
                                    {t("PRETS_AMORTISSABLES_AUX_PARTICULIERS.texte.partie11")}
                                </label>

                            </motion.div>
                        </Box>

                        <Box>
                            <motion.div
                                whileHover={{ scale: 1, rotate: 1 }}
                                whileTap={{
                                    scale: 1,
                                    rotate: -1,
                                }}
                            >
                                <img style={{ borderRadius: "10%" }} width={300} src={require("../../Database/Files/pret/teacher-helping-kids-class 1.png")} alt="" />
                            </motion.div>
                        </Box>
                    </Box>
                    <br /><br />
                    <label style={{ fontWeight: "bold" }} className='textgray' htmlFor="">
                        {t("PRETS_AMORTISSABLES_AUX_PARTICULIERS.texte.partie34")}
                    </label>
                    <br /><br />
                    <List style={{ borderLeft: "5px #FFA412 solid" }}>
                        {(t("PRETS_AMORTISSABLES_AUX_PARTICULIERS.texte.partie35").split("|")).map((t) => (
                            <>
                                <ListItem>
                                    <ListItemAvatar>
                                        <Avatar alt="Remy Sharp"><TextFields /></Avatar>
                                    </ListItemAvatar>
                                    <ListItemText
                                        primary={t}
                                    />
                                </ListItem>
                                <Divider variant="inset" component="li" />
                            </>
                        ))}
                    </List>
                    <br />
                    <label style={{ fontWeight: "bold" }} className='textgray' htmlFor="">
                        {t("PRETS_AMORTISSABLES_AUX_PARTICULIERS.texte.partie36")}
                    </label>
                    <br /><br />
                    <List style={{ borderLeft: "5px #FFA412 solid" }}>
                        {(t("PRETS_AMORTISSABLES_AUX_PARTICULIERS.texte.partie37").split("|")).map((t) => (
                            <>
                                <ListItem>
                                    <ListItemAvatar>
                                        <Avatar alt="Remy Sharp"><TextFields /></Avatar>
                                    </ListItemAvatar>
                                    <ListItemText
                                        primary={t}
                                    />
                                </ListItem>
                                <Divider variant="inset" component="li" />
                            </>
                        ))}
                    </List>
                    <br />

                    <label style={{ fontWeight: "bold" }} className='textgray' htmlFor="">
                        {t("PRETS_AMORTISSABLES_AUX_PARTICULIERS.texte.partie38")}
                    </label>

                    <br />

                    <label className='textgray' htmlFor="">
                        {t("PRETS_AMORTISSABLES_AUX_PARTICULIERS.texte.partie39")}
                    </label>

                    <br />

                    <i style={{ fontWeight: "bold" }} className='textgray'>
                        {t("PRETS_AMORTISSABLES_AUX_PARTICULIERS.texte.partie40")}
                    </i>

                    <br /><br />

                    <Box >
                        <img width={"50%"} src={illution_4} alt="" /> <br />
                        <Box width={20} />
                        <motion.div
                            initial="offscreen"
                            whileInView="onscreen"
                            viewport={{ once: true, amount: 0.8 }}
                            variants={scroll}
                            className='produitsEtServices'
                        >

                            <label className='textgray' style={{ fontSize: 'x-large', fontWeight: "bold", color: "#40805C", width: "100%" }} htmlFor="">
                                {t("PRETS_AMORTISSABLES_AUX_PARTICULIERS.texte.partie12").toUpperCase()}
                            </label>
                        </motion.div>
                    </Box>
                    <br />
                    <Box display={"flex"} gap={20}>
                        <Box>
                            <motion.div
                                initial="offscreen"
                                whileInView="onscreen"
                                viewport={{ once: true, amount: 0.8 }}
                                variants={scroll}
                                className='produitsEtServices'
                            >
                                <label className='textgray' htmlFor="">
                                    {t("PRETS_AMORTISSABLES_AUX_PARTICULIERS.texte.partie13")}
                                </label>
                            </motion.div>
                        </Box>
                        <Box>
                            <motion.div
                                whileHover={{ scale: 1, rotate: 1 }}
                                whileTap={{
                                    scale: 1,
                                    rotate: -1,
                                }}
                            >
                                <img style={{ borderRadius: "10%" }} width={300} src={require("../../Database/Files/pret/happy-car-buyer-new-car-owner-concept-portrait-excited-young-african-american-guy-dealership-showroom 1.png")} alt="" />
                            </motion.div>
                        </Box>
                    </Box>
                    <br />
                    <motion.div
                        initial="offscreen"
                        whileInView="onscreen"
                        viewport={{ once: true, amount: 0.8 }}
                        variants={scroll}
                        className='produitsEtServices'
                    >
                        <label className='textgray' htmlFor="">
                            {t("PRETS_AMORTISSABLES_AUX_PARTICULIERS.texte.partie41")}
                        </label>
                    </motion.div>
                    <br />
                    <motion.div
                        initial="offscreen"
                        whileInView="onscreen"
                        viewport={{ once: true, amount: 0.8 }}
                        variants={scroll}
                        className='produitsEtServices'
                    >
                        <label style={{ fontWeight: "bold" }} className='textgray' htmlFor="">
                            {t("PRETS_AMORTISSABLES_AUX_PARTICULIERS.texte.partie42")}
                        </label>
                    </motion.div>
                    <br />
                    <List style={{ borderLeft: "5px #FFA412 solid" }}>
                        {(t("PRETS_AMORTISSABLES_AUX_PARTICULIERS.texte.partie43").split("|")).map((t) => (
                            <>
                                <ListItem>
                                    <ListItemAvatar>
                                        <Avatar alt="Remy Sharp"><TextFields /></Avatar>
                                    </ListItemAvatar>
                                    <ListItemText
                                        primary={t}
                                    />
                                </ListItem>
                                <Divider variant="inset" component="li" />
                            </>
                        ))}
                    </List>
                    <br />
                    <motion.div
                        initial="offscreen"
                        whileInView="onscreen"
                        viewport={{ once: true, amount: 0.8 }}
                        variants={scroll}
                        className='produitsEtServices'
                    >
                        <label style={{ fontWeight: "bold" }} className='textgray' htmlFor="">
                            {t("PRETS_AMORTISSABLES_AUX_PARTICULIERS.texte.partie44")}
                        </label>
                    </motion.div>
                    <br />
                    <List style={{ borderLeft: "5px #FFA412 solid" }}>
                        {(t("PRETS_AMORTISSABLES_AUX_PARTICULIERS.texte.partie45").split("|")).map((t) => (
                            <>
                                <ListItem>
                                    <ListItemAvatar>
                                        <Avatar alt="Remy Sharp"><TextFields /></Avatar>
                                    </ListItemAvatar>
                                    <ListItemText
                                        primary={t}
                                    />
                                </ListItem>
                                <Divider variant="inset" component="li" />
                            </>
                        ))}
                    </List>
                    <br />
                    <motion.div
                        initial="offscreen"
                        whileInView="onscreen"
                        viewport={{ once: true, amount: 0.8 }}
                        variants={scroll}
                        className='produitsEtServices'
                    >
                        <label className='textgray' htmlFor="">
                            {t("PRETS_AMORTISSABLES_AUX_PARTICULIERS.texte.partie46")}
                        </label>
                    </motion.div>

                    <br /><br />

                    <Box display={"flex"} gap={20}>

                        <Box>
                            <motion.div
                                whileHover={{ scale: 1, rotate: 1 }}
                                whileTap={{
                                    scale: 1,
                                    rotate: -1,
                                }}
                            >
                                <img style={{ borderRadius: "10%" }} width={300} src={require("../../Database/Files/pret/portrait-businessman-using-laptop-browse-internet-startup-office-doing-project-research-executive-manager-sending-paperwork-email-working-website-browser-application 1.png")} alt="" />
                            </motion.div>
                        </Box>
                        <Box>
                            <Box >
                                <img width={"80%"} src={illution_4} alt="" /> <br />
                                <Box width={20} />
                                <motion.div
                                    initial="offscreen"
                                    whileInView="onscreen"
                                    viewport={{ once: true, amount: 0.8 }}
                                    variants={scroll}
                                    className='produitsEtServices'
                                >

                                    <label className='textgray' style={{ fontSize: 'x-large', fontWeight: "bold", color: "#40805C", width: "100%" }} htmlFor="">
                                        {t("PRETS_AMORTISSABLES_AUX_PARTICULIERS.texte.partie14").toUpperCase()}
                                    </label>
                                </motion.div>
                            </Box>
                            <br />
                            <motion.div
                                initial="offscreen"
                                whileInView="onscreen"
                                viewport={{ once: true, amount: 0.8 }}
                                variants={scroll}
                                className='produitsEtServices'
                            >
                                <label className='textgray' style={{ width: "30%", textAlign: "justify" }} htmlFor="">
                                    {t("PRETS_AMORTISSABLES_AUX_PARTICULIERS.texte.partie15")}
                                </label>
                            </motion.div>
                        </Box>
                    </Box>

                    <br />
                    <motion.div
                        initial="offscreen"
                        whileInView="onscreen"
                        viewport={{ once: true, amount: 0.8 }}
                        variants={scroll}
                        className='produitsEtServices'
                    >
                        <label className='textgray' style={{ width: "30%", textAlign: "justify" }} htmlFor="">
                            {t("PRETS_AMORTISSABLES_AUX_PARTICULIERS.texte.partie47")}
                        </label>
                    </motion.div>
                    <br />
                    <motion.div
                        initial="offscreen"
                        whileInView="onscreen"
                        viewport={{ once: true, amount: 0.8 }}
                        variants={scroll}
                        className='produitsEtServices'
                    >
                        <label className='textgray' style={{ width: "30%", textAlign: "justify", fontWeight: "bold" }} htmlFor="">
                            {t("PRETS_AMORTISSABLES_AUX_PARTICULIERS.texte.partie48")}
                        </label>
                    </motion.div>
                    <br />
                    <List style={{ borderLeft: "5px #FFA412 solid" }}>
                        {(t("PRETS_AMORTISSABLES_AUX_PARTICULIERS.texte.partie49").split("|")).map((t) => (
                            <>
                                <ListItem>
                                    <ListItemAvatar>
                                        <Avatar alt="Remy Sharp"><TextFields /></Avatar>
                                    </ListItemAvatar>
                                    <ListItemText
                                        primary={t}
                                    />
                                </ListItem>
                                <Divider variant="inset" component="li" />
                            </>
                        ))}
                    </List>




                    <br />
                    <motion.div
                        initial="offscreen"
                        whileInView="onscreen"
                        viewport={{ once: true, amount: 0.8 }}
                        variants={scroll}
                        className='produitsEtServices'
                    >
                        <label className='textgray' style={{ width: "30%", textAlign: "justify", fontWeight: "bold" }} htmlFor="">
                            {t("PRETS_AMORTISSABLES_AUX_PARTICULIERS.texte.partie50")}
                        </label>
                    </motion.div>
                    <br />
                    <List style={{ borderLeft: "5px #FFA412 solid" }}>
                        {(t("PRETS_AMORTISSABLES_AUX_PARTICULIERS.texte.partie51").split("|")).map((t) => (
                            <>
                                <ListItem>
                                    <ListItemAvatar>
                                        <Avatar alt="Remy Sharp"><TextFields /></Avatar>
                                    </ListItemAvatar>
                                    <ListItemText
                                        primary={t}
                                    />
                                </ListItem>
                                <Divider variant="inset" component="li" />
                            </>
                        ))}
                    </List>



                    <br />
                    <motion.div
                        initial="offscreen"
                        whileInView="onscreen"
                        viewport={{ once: true, amount: 0.8 }}
                        variants={scroll}
                        className='produitsEtServices'
                    >
                        <label className='textgray' style={{ width: "30%", textAlign: "justify", fontWeight: "bold" }} htmlFor="">
                            {t("PRETS_AMORTISSABLES_AUX_PARTICULIERS.texte.partie52")}
                        </label>
                    </motion.div>
                    <br />
                    <List style={{ borderLeft: "5px #FFA412 solid" }}>
                        {(t("PRETS_AMORTISSABLES_AUX_PARTICULIERS.texte.partie53").split("|")).map((t) => (
                            <>
                                <ListItem>
                                    <ListItemAvatar>
                                        <Avatar alt="Remy Sharp"><TextFields /></Avatar>
                                    </ListItemAvatar>
                                    <ListItemText
                                        primary={t}
                                    />
                                </ListItem>
                                <Divider variant="inset" component="li" />
                            </>
                        ))}
                    </List>



                    <br />
                    <motion.div
                        initial="offscreen"
                        whileInView="onscreen"
                        viewport={{ once: true, amount: 0.8 }}
                        variants={scroll}
                        className='produitsEtServices'
                    >
                        <label className='textgray' style={{ width: "30%", textAlign: "justify", fontWeight: "bold" }} htmlFor="">
                            {t("PRETS_AMORTISSABLES_AUX_PARTICULIERS.texte.partie54")}
                        </label>
                    </motion.div>
                    <br />
                    <List style={{ borderLeft: "5px #FFA412 solid" }}>
                        {(t("PRETS_AMORTISSABLES_AUX_PARTICULIERS.texte.partie55").split("|")).map((t) => (
                            <>
                                <ListItem>
                                    <ListItemAvatar>
                                        <Avatar alt="Remy Sharp"><TextFields /></Avatar>
                                    </ListItemAvatar>
                                    <ListItemText
                                        primary={t}
                                    />
                                </ListItem>
                                <Divider variant="inset" component="li" />
                            </>
                        ))}
                    </List>
                    <br />
                    <motion.div
                        initial="offscreen"
                        whileInView="onscreen"
                        viewport={{ once: true, amount: 0.8 }}
                        variants={scroll}
                        className='produitsEtServices'
                    >
                        <label className='textgray' style={{ width: "30%", textAlign: "justify" }} htmlFor="">
                            {t("PRETS_AMORTISSABLES_AUX_PARTICULIERS.texte.partie56")}
                        </label>
                    </motion.div>

                    <br />

                    <Box display={"flex"} gap={20}>
                        <Box>
                            <img width={"80%"} src={illution_4} alt="" /> <br />
                            <Box width={20} />
                            <motion.div
                                initial="offscreen"
                                whileInView="onscreen"
                                viewport={{ once: true, amount: 0.8 }}
                                variants={scroll}
                                className='produitsEtServices'
                            >

                                <label className='textgray' style={{ fontSize: 'x-large', fontWeight: "bold", color: "#40805C", width: "100%" }} htmlFor="">
                                    {t("PRETS_AMORTISSABLES_AUX_PARTICULIERS.texte.partie16").toUpperCase()}
                                </label>
                            </motion.div>
                            <br />
                            <motion.div
                                initial="offscreen"
                                whileInView="onscreen"
                                viewport={{ once: true, amount: 0.8 }}
                                variants={scroll}
                                className='produitsEtServices'
                            >
                                <label className='textgray' style={{ width: "30%", textAlign: "justify", fontSize: "large" }} htmlFor="">
                                    {t("PRETS_AMORTISSABLES_AUX_PARTICULIERS.texte.partie17")}
                                </label><br /><br />

                                <label className='textgray' style={{ width: "30%", textAlign: "justify", fontSize: "large" }} htmlFor="">
                                    {t("PRETS_AMORTISSABLES_AUX_PARTICULIERS.texte.partie18")}
                                </label><br /><br />

                                <List style={{ borderLeft: "5px #FFA412 solid" }}>
                                    {(t("PRETS_AMORTISSABLES_AUX_PARTICULIERS.texte.partie19").split("|")).map((t) => (
                                        <>
                                            <ListItem>
                                                <ListItemAvatar>
                                                    <Avatar alt="Remy Sharp"><TextFields /></Avatar>
                                                </ListItemAvatar>
                                                <ListItemText
                                                    primary={t}
                                                />
                                            </ListItem>
                                            <Divider variant="inset" component="li" />
                                        </>
                                    ))}
                                </List>
                                <br />
                                <label className='textgray' htmlFor="">
                                    {t("PRETS_AMORTISSABLES_AUX_PARTICULIERS.texte.partie10")}
                                </label>
                                <br /><br />
                                <label className='textgray' htmlFor="">
                                    {t("PRETS_AMORTISSABLES_AUX_PARTICULIERS.texte.partie11")}
                                </label>
                            </motion.div>
                        </Box>
                        <Box>
                            <motion.div
                                whileHover={{ scale: 1, rotate: 1 }}
                                whileTap={{
                                    scale: 1,
                                    rotate: -1,
                                }}
                            >
                                <img style={{ borderRadius: "10%" }} width={300} src={"https://avenir-gendarmerie.org/wp-content/uploads/2019/11/compte-epargne.jpg"} alt="" />
                            </motion.div>
                        </Box>
                    </Box>

                    <br />
                    <label className='textgray' htmlFor="">
                        {t("PRETS_AMORTISSABLES_AUX_PARTICULIERS.texte.partie57")}
                    </label>
                    <br /><br />

                    <label style={{ fontWeight: "bold" }} className='textgray' htmlFor="">
                        {t("PRETS_AMORTISSABLES_AUX_PARTICULIERS.texte.partie58")}
                    </label>
                    <br />
                    <List style={{ borderLeft: "5px #FFA412 solid" }}>
                        {(t("PRETS_AMORTISSABLES_AUX_PARTICULIERS.texte.partie59").split("|")).map((t) => (
                            <>
                                <ListItem>
                                    <ListItemAvatar>
                                        <Avatar alt="Remy Sharp"><TextFields /></Avatar>
                                    </ListItemAvatar>
                                    <ListItemText
                                        primary={t}
                                    />
                                </ListItem>
                                <Divider variant="inset" component="li" />
                            </>
                        ))}
                    </List>
                    <br />

                    <label style={{ fontWeight: "bold" }} className='textgray' htmlFor="">
                        {t("PRETS_AMORTISSABLES_AUX_PARTICULIERS.texte.partie60")}
                    </label>
                    <br />
                    <List style={{ borderLeft: "5px #FFA412 solid" }}>
                        {(t("PRETS_AMORTISSABLES_AUX_PARTICULIERS.texte.partie61").split("|")).map((t) => (
                            <>
                                <ListItem>
                                    <ListItemAvatar>
                                        <Avatar alt="Remy Sharp"><TextFields /></Avatar>
                                    </ListItemAvatar>
                                    <ListItemText
                                        primary={t}
                                    />
                                </ListItem>
                                <Divider variant="inset" component="li" />
                            </>
                        ))}
                    </List>
                    <br />

                    <label style={{ fontWeight: "bold" }} className='textgray' htmlFor="">
                        {t("PRETS_AMORTISSABLES_AUX_PARTICULIERS.texte.partie62")}
                    </label>
                    <br />

                    <label className='textgray' htmlFor="">
                        {t("PRETS_AMORTISSABLES_AUX_PARTICULIERS.texte.partie63")}
                    </label>
                    <br /><br />

                    <label className='textgray' style={{ fontWeight: "bold" }} htmlFor="">
                        <i>{t("PRETS_AMORTISSABLES_AUX_PARTICULIERS.texte.partie64")}</i>
                    </label>

                    <img width={"50%"} src={illution_4} alt="" />
                    <br /><br />
                </Container>
                <img style={{ width: "5%", marginLeft: "2%" }} draggable={false} src={EllipseDroite} alt="" />
            </Box>
            <br /><br />


            <br /><br /><br />



            <Footer />
        </div>
    )
}
export default PretPourParticuliers